import { FiPlus, FiMinus } from "react-icons/fi";
import { motion } from "framer-motion";
import FAQAnswers from "../components/FAQAnswers";
export const Accordion = ({ question, answer, isOpen, onClick }) => {
  return (
    <div className="border-b last:border-b-0 ">
      <button
        className={`w-full flex justify-between items-center p-6 ${"bg-white"} transition text-left`}
        onClick={onClick}
      >
        <span className="font-medium text-gray-800">{question}</span>
        {isOpen ? (
          <FiMinus className="text-gray-800" />
        ) : (
          <FiPlus className="text-gray-800" />
        )}
      </button>
      <motion.div
        initial={false}
        animate={isOpen ? "open" : "closed"}
        variants={{
          open: {
            opacity: 1,
            height: "auto",
            transition: { duration: 0.4, ease: "easeInOut" },
          },
          closed: {
            opacity: 0,
            height: 0,
            transition: { duration: 0.3, ease: "easeInOut" },
          },
        }}
        className="overflow-hidden"
      >
        <motion.div
          variants={{
            open: {
              opacity: 1,
              y: 0,
              transition: { duration: 0.3, ease: "easeIn", delay: 0.3 },
            },
            closed: { opacity: 0, y: -10 },
          }}
          className="p-6 pt-0 bg-white text-gray-700"
        >
          <FAQAnswers answer={answer} />
        </motion.div>
      </motion.div>
    </div>
  );
};
